module.exports = __webpack_public_path__ + "img/undraw_Mobile_life_re_jtih.d2911d7f.svg";